@if ((amount && amount !== 0) || (originalAmount && originalAmount !== 0)) {
    @if (!isSubTotal) {
        <div class="ap-flex ap-flex-gap-2">
            <div id="{{ id() }}_label" class="ap-flex-basis-75 ap-textarea">
                {{ label + '.label' | apContent }}
                @if (additionalInfo) {
                    <additional-info
                        id="{{ id() }}_hint"
                        class="text-primary"
                        [type]="hintType.ICON"
                        [key]="key"
                        titleKey="{{ label }}.additional-info.title"
                        contentKey="{{ label }}.additional-info.content"
                        [params]="additionalInfoParam"
                    >
                    </additional-info>
                }
            </div>

            <div class="ap-flex-basis-25 ap-text-align-right">
                @if (originalAmount) {
                    <ap-amount-display
                        class="ap-float-left"
                        id="{{ id() }}_amount"
                        [cancelled]="true"
                        [value]="originalAmount"
                        [minFractionDigits]="0"
                        [maxFractionDigits]="0"
                    ></ap-amount-display>
                }
                <ap-amount-display
                    id="{{ id() }}_amount"
                    [value]="amount"
                    [minFractionDigits]="0"
                    [maxFractionDigits]="0"
                ></ap-amount-display>
            </div>
        </div>
    } @else {
        <div [ngClass]="{ totalRow: totalRow, 'ap-padding-2': totalRow, 'ap-margin-top-2': totalRow }" class="ap-flex ap-flex-gap-2">
            <div id="{{ id() }}_label" class="ap-flex-basis-75 bold ap-textarea">
                {{ label + '.label' | apContent }}
            </div>

            <div class="ap-flex-basis-25 ap-text-align-right">
                <ap-amount-display
                    id="{{ id() }}_amount"
                    [emphasize]="true"
                    [minFractionDigits]="0"
                    [maxFractionDigits]="0"
                    [value]="amount"
                ></ap-amount-display>
            </div>
        </div>
    }
}
